import { GetStaticPropsContext, InferGetStaticPropsType } from "next";
import ErrorPage from "next/error";
import Head from "next/head";
import CelebrityImage from "../../components/celebrity-image";
import Layout from "../../components/layout";
import SEOMeta from "../../components/SEOMeta";
import BlogSidebar from "../../components/sidebar/BlogSidebar";
import WebShare from "../../components/WebShare";
import {
  getAllCelebrity,
  getCelebsAndMorePosts,
  getLatestBlogs,
  getPopularBlogs,
} from "../../lib/api";

function celebrity({
  post,
  sidebarLatestPosts,
  sidebarPopularPosts,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  if (!post) return <ErrorPage statusCode={404} />;

  const postTitle = post.title.split(" ");
  const celebrityName = postTitle[0];
  const celebritySurname = postTitle[1];

  const latestPosts = sidebarLatestPosts.edges;
  const popularPosts = sidebarPopularPosts.edges;

  //console.log(post)

  return (
    <Layout>
      
      <Head>
        <title>{post?.seo?.title}</title>
        <SEOMeta seoData={post.seo} type="celebrity"/>
      </Head>

      <header className="single-celebrity-banner mt-5 mb-5">
        <div className="container">
          <div className="row gap-5">
            <div className="col-lg-5">
              <article className="title-contner">
                <h1 className="title">{celebrityName}</h1>
                <h2 className="sub-title">{celebritySurname}</h2>
              </article>
              <article className="sec-dsc">
                <div dangerouslySetInnerHTML={{ __html: post.excerpt }} />
              </article>
            </div>
            <div className="col order-first order-lg-last">
              <div className="banner-img-wrapper ">
                {post.featuredImage && (
                  <CelebrityImage
                    firstName={celebrityName}
                    coverImage={post.featuredImage}
                    imgWidth={600}
                    imgHeight={600}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="main-block-sec mt-5 mb-5">
        <div className="container">
          <div className="row">
            <article className="col-lg-8 col-sm-12">
              <div
                className="common-bio-wrapper"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />

              <WebShare uri={post.uri} title={post.title}/>

            </article>

            <div className="col-lg-4">
              <BlogSidebar
                latestPosts={latestPosts}
                popularPosts={popularPosts}
                pageType={true}
              />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default celebrity;

export async function getStaticProps({
  params,
  preview = false,
  previewData,
}: GetStaticPropsContext) {
  const limit = 5;
  const slug = typeof params.slug == "string" ? params.slug : params.slug[0];
  const data = await getCelebsAndMorePosts(slug, preview, previewData);
  const sidebarLatestPosts = await getLatestBlogs(limit, preview);
  const sidebarPopularPosts = await getPopularBlogs(limit, preview);

  if (typeof data == "undefined") {
    return { props: {}, revalidate: 60 * 60 * 24 };
  }

  return {
    props: {
      preview,
      post: data.celebrityBy,
      sidebarLatestPosts,
      sidebarPopularPosts,
    },
    revalidate: 60 * 60 * 24,
  };
}

export async function getStaticPaths() {
  const allCeleb = await getAllCelebrity();

  if (typeof allCeleb == "undefined" || !allCeleb || !allCeleb) {
    return { paths: [], fallback: false };
  }

  return {
    paths: allCeleb.map(({ node }) => `/celebrity/${node.slug}`) || [],
    fallback: true,
  };
}
